import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Privacy from './component/Privacy';
import Terms from './component/Terms';
import '../style/Blog.css';
import '../style/Home.css';
import '../style/Privacy.css';

const PrivacyPage = () => {
  const navigate = useNavigate();
  const [showTerms, setShowTerms] = useState(false);

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="main privacy-main">
      <Helmet>
        <title>Privacy Policy | Aberrest</title>
        <meta name="description" content="Privacy policy for the Aberrest website." />
      </Helmet>

      <header className="header">
        <div
          className="brand-block"
          onClick={goHome}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goHome();
            }
          }}
        >
          <h1 className="title">Aberrest</h1>
          <h2 className="subtitle">Applied AI for Alts</h2>
        </div>
        <div
          className="logo-animated"
          onClick={goHome}
          role="button"
          tabIndex={0}
          aria-label="Home"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goHome();
            }
          }}
        />
      </header>

      <div className="privacy-page">
        <div
          className="back-button"
          onClick={goHome}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goHome();
            }
          }}
        >
          ← Home
        </div>
        <Privacy />
      </div>

      {showTerms && (
        <div className="overlay active" onClick={() => setShowTerms(false)}>
          <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
            <span className="overlay-close" onClick={() => setShowTerms(false)}>&times;</span>
            <Terms />
          </div>
        </div>
      )}

      <footer className="footer">
        <button type="button" className="footer-text-button" onClick={() => setShowTerms(true)}>Terms of Use</button>
        <Link to="/privacy" aria-current="page">Privacy Policy</Link>
        <span> Aberrest © 2021-Present. All rights reserved.</span>
      </footer>
    </div>
  );
};

export default PrivacyPage;
